document.addEventListener('DOMContentLoaded', () => {
    $('.gallery-zoom-viewer').click(function() {
      $('.product-media-modal').attr('open', '')
    })


    //  sku切换 
    var optionsList = []

    $('.pro-option').click(function(){
      optionsList = []
      $(this).siblings('.pro-option').removeClass('selected')
      $(this).addClass('selected')
      $(this).parents('variant-selects').find('.pro-option.selected').each(function() {
        optionsList.push($(this).text().trim());
      });

      console.log(optionsList)
      
      var variantsList = $(this).parents('.product__info-container').find('.product-sku-list li')

      variantsList.each(function() {
        var optionvalue = $(this).attr('value').trim()
        var containsAllValues = optionsList.every(function(value) {
          return optionvalue.includes(value);
        });

        if (containsAllValues) {
          sku = $(this).text()
          url = $(this).attr('url')
          $('.product__sku span').text(sku)
          $('.gallery-zoom-viewer .product__modal-opener .product__media img').attr('src', url)
          $('.zoomWindow').css('background-image', `url(${url})`)
          return false;
        } else {
          $('.product__sku span').text('')
        }

      })

    
    })

    // payment 按钮背景色 
     function btnColor () {
      var width = $(window).width();
      var btnText = $('.shopify-payment-button shopify-accelerated-checkout').text()
      if(width < 1150) {
        if (btnText === 'Buy it now') {
          $('.shopify-payment-button').css('background-color', '#339bcb')
        } else {
          $('.shopify-payment-button').css('background-color', '#5433eb')
        }
      } else {
        $('.shopify-payment-button').css('background-color', 'transparent')
      }
    }

    setTimeout(function(){
      btnColor()
    },2000)
    

    $(window).on('resize', function() {
      btnColor()
    });




    // 产品图片放大镜
    $('.thumbnail-list__item').click(function(){
      var zoomUrl = $(this).find('img').attr('src')
      $('.zoomWindow').css('background-image', `url(${zoomUrl})`)
    })

  });